import React, { useState, useEffect } from 'react';
import Typography from '@mui/material/Typography';
import './App.css';
import { LocationPinMap } from 'material-ui-location-pin-map';

import AssistedCSVUploader from './AssistedCSVUploader/AssistedCSVUploader';
import { convertToGeoJSON, parseCSV } from './data';

function Simple() {
    const [data, setData] = useState([]);

    useEffect(() => {
        console.log(data);
    }, [data]);

    const handleDataChange = async (blob) => {
        const text = await blob.text();
        const parsedData = await parseCSV(text);
        setData(parsedData);
    };

    return (
        <div
            className="App"
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                padding: '20px'
            }}
        >
            <Typography variant="h2" style={{ marginBottom: '20px' }}>
                Map Maker
            </Typography>
            <div
                className="map-div"
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '20px',
                    width: '100%',    // Let it expand to full width
                    maxWidth: '1200px' // Maybe a max-width to keep it reasonable
                }}
            >
                <div style={{ width: '80%' }}>
                    {/* Increase width here to make the CSV Uploader appear bigger */}
                    <AssistedCSVUploader
                        columns={['Title', 'Description', 'Address', 'Lat', 'Long']}
                        onChange={handleDataChange}
                        style={{ width: '100%', padding: '20px' }} // Add padding if supported
                    />
                </div>
                {data && (
                    <div style={{ width: '100%', minHeight: '600px' }}>
                        <LocationPinMap
                            data={convertToGeoJSON(data)}
                            title={"Locations"}
                            accessToken={process.env.REACT_APP_MAPBOX_ACCESS_TOKEN}
                            style={{ width: '100%', height: '100%', minHeight: '600px' }}
                        />
                    </div>
                )}
            </div>
        </div >
    );
}

export default Simple;
